export type ArticleListFilters = {
  url?: string;
  status?: string | null;
  createdFrom?: string | null;
  createdTo?: string | null;
};

export type ArticleDetails = {
  article: Article;
  errors: Array<{ id: string; message: string }>;
  similarities: {
    id: string;
    title: string;
    date?: string;
    snippet: string;
    createdAt: Date;
    taskId: string;
    url: string;
    searchEngine: string;
    screenshotId?: string;
    domain: string,
    count: number
  }[];
};

export type GetArticlesPayload = ArticleListFilters & {
  limit?: number;
  offset?: number;
};

export enum ArticleStatus {
  pending = "pending",
  completed = "completed",
  failed = "failed",
}

export type Article = {
  id: string;
  originalUrl: string;
  date?: null | string;
  title: string;
  snippet: string | null;
  createdAt: string;
  updatedAt: string;
  status: ArticleStatus;
  campaignId: string | null;
  options: string | null;
};

export type GetArticlesResponse = {
  data: Article[];
  meta: {
    total: number;
  };
};

export type CreateArticlePayload = {
  campaignId: number;
  articles: {
    url: string;
    date?: Date;
  }[];
};

export type CreateArticleResponse = {
  id: string;
};
